import { Component, EventEmitter, Output, signal } from '@angular/core';
import { ActiveProductReport, Product } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { ZorroModule } from '../../../../modules/zorro.module';
import { Column, ReportingTable } from '../reporting-table/reporting-table';
import { RowColumn } from '../reporting-table/row-column';
import { HeaderColumn } from '../reporting-table/header-column';
import { ActiveProductsReports } from '../../../../services/active-products-reports';

@Component({
	selector: 'app-products',
	imports: [CommonModule, ZorroModule, ReportingTable, RowColumn, HeaderColumn],
	standalone: true,
	templateUrl: './products.html',
	styleUrl: './products.scss',
})
export class Products {
	@Output('onSelectProduct') public onSelectProduct = new EventEmitter<Partial<Product>>();

	public loading = signal<boolean>(true);
	public rows = signal<ActiveProductReport[]>([]);
	public columns = signal<Column[]>([]);

	constructor(private activeProductsReports: ActiveProductsReports) {}

	ngOnInit() {
		this.loadProducts();
	}

	private async loadProducts(): Promise<void> {
		this.loading.set(true);

		try {
			const data = await this.activeProductsReports.getActiveProductsReport$();
			console.log('Loaded products:', data);
			this.rows.set(data);
			this.updateTableDetails();
		} catch (error) {
			console.error('Error loading products:', error);
		} finally {
			this.loading.set(false);
		}
	}

	private updateTableDetails(): void {
		this.columns.set([
			{
				key: 'productName',
				name: 'Product',
				sortOrder: 'ascend',
				sortFn: (a: ActiveProductReport, b: ActiveProductReport) => a.productName.localeCompare(b.productName),
				sortDirections: ['ascend', 'descend', null],
				filterMultiple: true,
				filterOptions: this.rows().map(row => ({ text: row.productName, value: row.productName })),
				filterFn: (list: string[], item: ActiveProductReport) =>
					list.some(name => item.productName.indexOf(name) !== -1),
			},
			{
				key: 'locationCount',
				name: 'Schools',
				sortOrder: null,
				sortFn: (a: ActiveProductReport, b: ActiveProductReport) =>
					a.locationCount.toString().localeCompare(b.locationCount.toString()),
				sortDirections: ['ascend', 'descend', null],
			},
			{
				key: 'teacherCount',
				name: 'Teachers',
				sortOrder: null,
				sortFn: (a: ActiveProductReport, b: ActiveProductReport) =>
					a.teacherCount.toString().localeCompare(b.teacherCount.toString()),
				sortDirections: ['ascend', 'descend', null],
			},
			{
				key: 'sectionCount',
				name: 'Classes',
				sortOrder: null,
				sortFn: (a: ActiveProductReport, b: ActiveProductReport) =>
					a.sectionCount.toString().localeCompare(b.sectionCount.toString()),
				sortDirections: ['ascend', 'descend', null],
			},
			{
				key: 'studentCount',
				name: 'Students',
				sortOrder: null,
				sortFn: (a: ActiveProductReport, b: ActiveProductReport) =>
					a.studentCount.toString().localeCompare(b.studentCount.toString()),
				sortDirections: ['ascend', 'descend', null],
			},
		]);
	}

	public async onRowClick(row: ActiveProductReport) {
		this.onSelectProduct.emit({
			name: row.productName,
			engine_name: row.engineName,
		});
	}
}
